var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none-list"},[_c('img',{attrs:{"src":require('@/assets/apply-list-none.png'),"alt":""}}),_c('span',{staticClass:"info"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }